import * as React from 'react'

export const CaptchaNote = () => {
  return (
    <div className='small text-gray-500'>
      This site is protected by reCAPTCHA and the Google&nbsp;
      <a href='https://policies.google.com/privacy'>Privacy Policy</a> and&nbsp;
      <a href='https://policies.google.com/terms'>Terms of Service</a> apply.
    </div>
  )
}
